import Make from './make'

const make = Make('log/')

interface Options {
  action: string
  longDescription: string
  websiteSection: string
}

export const logAction = async (data: Options): Promise<any> => {
  const req = await make.post({
    endpoint: 'log-action',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return true
}
